<template>
  <list-banner-mobile v-if="checkMobileDevice()" :banners="banners" :fetched="bannersFetched" />
  <list-banner v-else :banners="banners" :time-change-banner="timeChangeBanner" />
</template>

<script>
import { component } from '../../../../mixins/component';
import { helper } from '../../../../mixins/helper';
import { LandingAPI } from '../../../../api/landing';
import ListBanner from './ListBanner';
import ListBannerMobile from './ListBannerMobile';

export default {
  components: { ListBannerMobile, ListBanner },
  mixins: [component, helper, LandingAPI],
  data() {
    return {
      banners: [],
      bannersFetched: false,
      timeChangeBanner: 3000,
      tournament_info: {
        prize: 0,
        total_streamers: 0,
        total_users: 0,
      },
    };
  },
  created() {
    this.getListBanner();
  },
  methods: {
    async getListBanner() {
      try {
        let res;
        if (this.checkMobileDevice()) {
          res = await this.getListBannerMobileAPI();
          this.banners = res.data.list_banner;
        } else {
          res = await this.getListBannerAPI();
          this.banners = res.data.list_banner;
          this.timeChangeBanner = res.data.time_change_banner;
          this.tournament_info = res.data.tournament_info;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.bannersFetched = true;
      }
    },
  },
};
</script>
